/** The `events` columns liveness depends on. */
export type EventLiveness = {
  end_date?: string | null;
  is_active?: boolean | null;
};

/**
 * Has this event not ended yet?
 *
 * The rule the chat lists apply everywhere: an inactive event, or one whose end_date has
 * passed, drops out. Enforced client-side rather than in RLS on purpose -- an ended
 * event's history stays readable, it just stops being listed.
 */
export function isEventLive(event: EventLiveness | null | undefined, now: number = Date.now()): boolean {
  if (!event) return false;
  if (event.is_active === false) return false;
  if (event.end_date != null && new Date(event.end_date).getTime() < now) return false;
  return true;
}
